import Switch from './Switch.vue';

Switch.install = (Vue) => {
  Vue.component(Switch.name, Switch);
};

export default Switch;
